import React, {Component} from "react";
import {connect} from 'react-redux';
import styles from '../view/stockVideo/music/FJMusicMedias.module.less';
import classNames from 'classnames';
import FJMusicLeftMenu from "../view/stockVideo/music/FJMusicLeftMenu";
import FJMusicFilterPanel from "../view/stockVideo/music/FJMusicFilterPanel";
import FJMusicSearchView from "../view/stockVideo/music/FJMusicSearchView";
import FJSearch from "../view/stockVideo/search/FJSearch";
import FJMusicCollectionContainer from "./FJMusicCollectionContainer";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJMedia from "../../../store/FJMedia";
import {FJStockVideoAction} from "../../../redux/action/FJRoot.action";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJLocalStore from "../../../store/FJLocalStore";
import _ from 'lodash'
import FJUtil from "../../../util/FJUtil";

class FJMusicMediasContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpenLeftMenu: true,
		};
    this._inputValueWithChange = '';
	}

	_onSearch = (value) => {
		const {sortType, filter} = this.props;
		const {onSearchAudio} = this.props;
		onSearchAudio(value, sortType, 1, filter);
	};

	_onSortChange = (sortType) => {
		const {filter} = this.props;
		const {onSearchAudio} = this.props;
		onSearchAudio(this._inputValueWithChange, sortType, 1, filter);
	};

	_onChange = (value) => {
    this._inputValueWithChange = value;
		if (value === '') {this._onClear()}
	};

	_onClear = () => {
		const {filter, sortType} = this.props;
		const {onSearchAudio} = this.props;
		onSearchAudio('', sortType, 1, filter);
	};

	_onSubmit = (id, preSelected, url, options) => {

		// 做埋点统计
		if (!preSelected) {
			const {
				keywords,
				filter
			} = this.props;

			let method = '';
			if (keywords) {
				method = 'search';
			}
			if (filter.mood || filter.instrument || filter.genre) {
				method = method ? method + '+filter' : 'filter';
			}
			if (!method) {
				method = 'collection';
			}
			FJUtil.ealog(
				'add music',
				{
					button: 'add stock music',
					"stock music retrieval method": method,
					editor: "timeline"
				});
		}
		this.props.toggleStockMedia(id, FJCoreConstant.AUDIO, FJMedia.MediaFromType().STOCK, !preSelected, url, options)
	};

	_onFilterClick = () => {
		this.setState({
			isOpenLeftMenu: !this.state.isOpenLeftMenu
		})
	}

	_onFilterChange = (cate, value, options) => {
		const {keywords, sortType, filter, setStockAudioStatus, onSearchAudio} = this.props;
		let nextFilter = _.cloneDeep(filter);
		if (cate === 'duration') {
			nextFilter = {...nextFilter, [cate]: value};
			setStockAudioStatus({searchAudioFilter: nextFilter});
			if (options && options.changeEnd) {
				onSearchAudio(keywords, sortType, 1, nextFilter);
			}
		} else {
			nextFilter[cate] = nextFilter[cate] === value ? '' : value;
			onSearchAudio(keywords, sortType, 1, nextFilter);
		}
	};

	_onRetry = () => {
		const {sortType, page, keywords, filter} = this.props;
		const {onSearchAudio} = this.props;
		onSearchAudio(keywords, sortType, page, filter);
	};

	_onNextPage = () => {
		const {sortType, page, keywords, filter, total} = this.props;
		const {onSearchAudio, searchMode} = this.props;
		if (total && searchMode === FJViewConstant.STOCK_SEARCH_SUCCESS) {
			onSearchAudio(keywords, sortType, page + 1, filter);
		}
	};

	render() {

		let {
			active,
			mediaList,
			audioPanelType,
			keywords,
			history,
			sortType,
			audioCategories,
			searchAudios,
			filter,
			searchMode,
			total,
			addTips,
			onClearHistory
		} = this.props;

		let {isOpenLeftMenu} = this.state;
		let viewInfo = {
			baseWidth: isOpenLeftMenu ? 370 : 323,
			space: isOpenLeftMenu ? 212 : 192
		}

		return (
			<div className={classNames(styles.music_container, {[styles.active]: active})}>
				<FJSearch couldSort
				          musicStyle
				          placeHolder={FJLocalStore._('search-audio')}
				          keywords={keywords}
				          sortType={sortType}
				          onChange={this._onChange}
				          onSortChange={this._onSortChange}
				          onClear={this._onClear}
				          value={keywords}
				          history={history}
				          onSubmit={this._onSearch}
				          visible={keywords !== ''}
									onClearHistory={onClearHistory}
				/>
				<div className={styles.view_container}>
					<div className={styles.content}>
						<FJMusicLeftMenu onFilterClick={this._onFilterClick}
						                 isOpenLeftMenu={isOpenLeftMenu}
						/>
						<FJMusicFilterPanel isOpenLeftMenu={isOpenLeftMenu}
						                    audioCategories={audioCategories}
						                    onChange={this._onFilterChange}
						                    filter={filter}
						/>
					</div>
				</div>
				<FJMusicCollectionContainer active={active && audioPanelType === 1}
				                            mediaList={mediaList}
				                            addMusic={this._onSubmit}
				                            isOpenLeftMenu={isOpenLeftMenu}/>
				<FJMusicSearchView active={active && audioPanelType === 2}
				                   onRetry={this._onRetry}
				                   searchStatus={FJUtil.getStatusWithStockSearch(searchMode, total, searchAudios.length)}
				                   filter={filter}
				                   mediaList={mediaList}
				                   onFilterChange={this._onFilterChange}
				                   searchNextPage={this._onNextPage}
				                   isOpenLeftMenu={isOpenLeftMenu}
				                   collections={searchAudios}
				                   keywords={keywords}
				                   total={total}
				                   viewInfo={viewInfo}
				                   addMusic={this._onSubmit}
				                   addTips={addTips}
				/>
			</div>
		)
	}

}

const mapStateToProps = function (state) {
	return {
		audioCategories: state.stock.audioCategories,
		mediaList: state.media.mediaList,
		filter: state.stock.searchAudioFilter,
		searchAudios: state.stock.searchAudios,
		keywords: state.stock.searchAudioKeyword,
		sortType: state.stock.searchAudioSortType,
		history: state.stock.searchAudioHistory,
		searchMode: state.stock.searchAudioMode,
		total: state.stock.searchAudioTotal,
		page: state.stock.searchAudioPage,
		audioPanelType: state.stock.audioPanelType,
	}

}

const mapDispatchToProps = function (dispatch) {
	return {
		onSearchAudio: function (keywords, sortType, page, filter) {
			dispatch(FJStockVideoAction.searchAudioAction(keywords, sortType, page, filter))
		},
		setStockAudioStatus: function (filter) {
			dispatch(FJStockVideoAction.setStockAudioStatusAction(filter))
		},
		toggleStockMedia: function (id, type, fromType, toggle, url, options) {
			dispatch(FJStockVideoAction.toggleStockMediaAction(id, type, fromType, toggle, url, options))
		},
		onClearHistory: function () {
			dispatch(FJStockVideoAction.deleteVideoHistoryAction(FJViewConstant.SEARCH_STOCK_MUSIC))
		},
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(FJMusicMediasContainer);
